import { ActionButton } from '../../../parts/index.js';
const sentence = (words: string) => /[.!?]$/.test(words) ? words : `${words}.`;
export function Loading({ reading }: { reading: string }) {
  return <div role="status"><div className="skel" aria-hidden="true" /><div className="skel" aria-hidden="true" /><p className="note">{reading.startsWith('Checking ') ? reading : `Reading ${reading}`}</p></div>;
}
export function CouldNotLoad({ what, at, onRetry }: { what: string; at?: string; onRetry: () => void }) {
  return <div role="alert"><p className="err">{what} could not be read.{at ? ` This is from ${at}.` : ''}</p><div className="opts"><ActionButton reading className="opt" onClick={onRetry}>Try again</ActionButton></div></div>;
}
export function Saved({ what }: { what: string }) {
  return <div className="okline" role="status">{sentence(what)}</div>;
}
export function Refused({ words }: { words: string }) { return <p className="err" role="alert">{words}</p>; }
export function NotSaved({ reason, onRetry }: { reason: string; onRetry: () => void }) {
  return <div className="err" role="alert"><span className="chip">Not saved yet</span><p>It was not saved: {sentence(reason)}</p><div className="opts"><ActionButton className="opt" onClick={onRetry}>Try again</ActionButton></div></div>;
}
